export default "__VITE_ASSET__a02d15bd__"